"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreisTyp = void 0;
var PreisTyp;
(function (PreisTyp) {
    PreisTyp["calculatedRing"] = "calculatedRing";
    PreisTyp["calculatedEinzelstueck"] = "calculatedEinzelstueck";
    PreisTyp["stueckpreis"] = "stueckpreis";
})(PreisTyp = exports.PreisTyp || (exports.PreisTyp = {}));
//# sourceMappingURL=PreisTyp.js.map